import React, { Dispatch, SetStateAction, useState } from "react";
import AddOneOne from "./SchedulerWrapper";
import AddGroup from "./AddGroup";
import AddGroupWebinar from "./AddGroupWebinar";
import { ToasterObject } from "./interface-utils";
import { PatientPersonalInfo } from "patients-experience-client";

type Reschedule = {
  isSchedule: boolean;
  appointmentCategory: string;
};

type AddAppointmentProps = {
  setOpenToaster: (toasterConfig: ToasterObject) => void;
  getAllAppointments?: () => void;
  isReschedule?: Reschedule;
  confirmPage?: any;
  confirmPageAction?: (action: any) => void;
  appointmentType?: (action: any) => void;
  offCanvasShow:boolean,
  offCanvasComp:string,
  setOffCanvasShow?:Dispatch<SetStateAction<boolean>>;
  setOffCanvasComp?:Dispatch<SetStateAction<string>>;
  appointmentId?:string;
  loadAppointmentDetails?:()=>void;
  reloadGrid?: () => void,
  patient?: PatientPersonalInfo;
}

const AddAppointmentRadio: React.FC<AddAppointmentProps> = ({
  setOpenToaster,
  // getAllAppointments,
  isReschedule,
  confirmPage,
  confirmPageAction,
  appointmentType,
  offCanvasShow,
  offCanvasComp,
  setOffCanvasShow,
  setOffCanvasComp,
  appointmentId,
  loadAppointmentDetails,
  reloadGrid,
  patient,
}) => {
  const [radioOption, setRadioOption] = useState("OneOne");

  const onRadioChanged = (e: React.ChangeEvent<HTMLInputElement>) => {
    setRadioOption(e.target.value);
    appointmentType && appointmentType(e.target.value);
  };

  // Render the component
  const renderComponent = () => {
    switch (radioOption) {
      case "OneOne":
        return (
          <AddOneOne
            // getAllAppointments={getAllAppointments}
            setOpenToaster={setOpenToaster}
            confirmPageAction={confirmPageAction}
            confirmType={"OneOne"}
            offCanvasShow={offCanvasShow}
            offCanvasComp={offCanvasComp}
            setOffCanvasShow={setOffCanvasShow!}
            setOffCanvasComp={setOffCanvasComp!}
            appointmentId={appointmentId}
            loadAppointmentDetails={ loadAppointmentDetails}
            reloadGrid={reloadGrid!}
            patient={patient}
          />
        );
      case "Group":
        return (
          <AddGroup
            // getAllAppointments={getAllAppointments}
            setOpenToaster={setOpenToaster}
            confirmPageAction={confirmPageAction}
            confirmType={"Group"}
          />
        );
      case "GroupWebinar":
        return (
          <AddGroupWebinar
            // getAllAppointments={getAllAppointments}
            setOpenToaster={setOpenToaster}
            // confirmPageAction={confirmPageAction}
            // confirmType={"GroupWebinar"}
          />
        );
    }
  };

  return (
    <div>
      {!confirmPage &&
      <div className="clearfix">
        <div className="form-check form-check-inline">
          <input
            className="form-check-input"
            type="radio"
            name="inlineRadioOptions"
            id="inlineRadio1"
            value="OneOne"
            onChange={(e) => onRadioChanged(e)}
            checked={radioOption === "OneOne"}
          />
          <label className="form-check-label" htmlFor="inlineRadio1">
            1 on 1 Appointment
          </label>
        </div>
        {/* <div className="form-check form-check-inline">
          <input
            className="form-check-input"
            type="radio"
            name="inlineRadioOptions"
            id="inlineRadio2"
            value="Group"
            onChange={(e) => onRadioChanged(e)}
            checked={radioOption === "Group"}
          />
          <label className="form-check-label" htmlFor="inlineRadio2">
            Group
          </label>
        </div>
        <div className="form-check form-check-inline">
          <input
            className="form-check-input"
            type="radio"
            name="inlineRadioOptions"
            id="inlineRadio3"
            value="GroupWebinar"
            onChange={(e) => onRadioChanged(e)}
            checked={radioOption === "GroupWebinar"}
          />
          <label className="form-check-label" htmlFor="inlineRadio3">
            Group Webinar
          </label>
        </div> */}
        </div>
      }
      <div>{renderComponent()}</div>
    </div>
  );
};

export default AddAppointmentRadio;
